import React from "react";
import { useLocation } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";

const PaymentPage = () => {
  const query = new URLSearchParams(useLocation().search);
  const customerName = query.get("name") || "Kupac";
  const amount = Number(query.get("amount")) || 35;

  // Formatiramo iznos za hrvatske banke (2 decimale, zarez)
  const formatAmount = (amount) => Number(amount).toFixed(2).replace(".", ",");

  // Tekst za QR (univerzalni, radi u većini hrvatskih banaka)
  const qrText = `
Platitelj: ${customerName}
Primatelj: Ema Šušak Vrhar
IBAN: HR0224070003239055930
Iznos: ${formatAmount(amount)} EUR
Opis: ${customerName}
  `;

  return (
    <div className="pocetna-container container mt-8">
      <div className="row">
      <h2>Plati putem mobilnog bankarstva</h2>
      <p>Plaćanje je potrebno izvršiti najkasnije do 15.07.2026.
      </p>
      <p>Ukoliko do tada ne bude izvršeno smatra se kao klasična prijava i plaća se kotizacija na ulazu!
        25€
      </p>
      <div className="container">
      <QRCodeCanvas value={qrText.trim()} size={220} />
      <p className="mt-3">
        Otvori mobilnu banku i skeniraj QR kod ili kopiraj podatke:
      </p>
      </div>
      <div className="container">
      <pre style={{ textAlign: "left", display: "inline-block" }}>
        {qrText.trim()}
      </pre>
      </div>
      </div>
    </div>
  );
};

export default PaymentPage;